import React from 'react'
import Headers from '../headers/Headers'
import Footers from '../footers/Footers'
import FooterCall from '../footers/FooterCall'

const WaterProofing = () => {
  return (
    <>
      <Headers/>
      <div>
        <h1>Water Proofing</h1>
      </div>
      <Footers/>
      <FooterCall/>
    </>
  )
}

export default WaterProofing
